import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getRMConfigs } from './configs.async'

const initialState = {
  clientConfigsData: [],
  clientConfigsLoader: true,
}

const RMConfigReducer = createSlice({
  name: 'RMConfigReducer',
  initialState,
  reducers: {
    emptyConfigReducer: (state) => {},
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getRMConfigs.pending), (state) => {
      state.clientConfigsLoader = true
    })
    builder.addMatcher(
      isAnyOf(getRMConfigs.fulfilled),
      (state, action) => {
        state.clientConfigsLoader = false
        state.clientConfigsData = action.payload.data
      },
    )
    builder.addMatcher(isAnyOf(getRMConfigs.rejected), (state) => {
      state.clientConfigsLoader = false
    })
  },
})

export const { emptyConfigReducer } = RMConfigReducer.actions
export default RMConfigReducer.reducer
